import React from 'react';
import { MapPin, Phone, MessageCircle, Clock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { SCHOOL } from '../../lib/constants';
import { useLeadModal } from '../../lib/leadModalContext';

const Contact = () => {
  const { openLeadModal } = useLeadModal();
  return (
    <section id="contact" className="relative py-16 sm:py-20" data-testid="contact-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 grid grid-cols-1 lg:grid-cols-12 gap-8">
        <div className="lg:col-span-6">
          <span className="font-display uppercase tracking-[0.22em] text-[11px] text-[color:var(--neon-red)]">
            Visit Us
          </span>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl text-white tracking-tight">
            The Revolution Location.
          </h2>
          <p className="mt-4 text-white/75 leading-relaxed">
            Our brand-new home in Colorado Springs. Walk-ins welcome — we’d love to show
            you the mat.
          </p>

          <div className="mt-6 panel rounded-2xl p-6 space-y-5">
            <div className="flex items-start gap-3">
              <MapPin className="h-5 w-5 text-[color:var(--neon-red)] mt-0.5" />
              <div>
                <div className="font-display uppercase tracking-[0.14em] text-[11px] text-white/55">
                  Address
                </div>
                <div className="text-white font-mono-ui text-sm mt-1" data-testid="contact-address">
                  {SCHOOL.address}
                </div>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <Phone className="h-5 w-5 text-[color:var(--neon-red)] mt-0.5" />
              <div className="flex-1">
                <div className="font-display uppercase tracking-[0.14em] text-[11px] text-white/55">
                  Phone
                </div>
                <a
                  href={SCHOOL.phoneHref}
                  className="block text-white hover:text-[color:var(--neon-red)] font-mono-ui text-sm mt-1"
                  data-testid="contact-call-link"
                >
                  {SCHOOL.phone}
                </a>
              </div>
              <a
                href={SCHOOL.smsHref}
                className="inline-flex items-center gap-1.5 text-[11px] font-display uppercase tracking-[0.14em] text-white/85 border border-white/15 rounded-lg px-3 py-2 min-h-[44px] hover:bg-white/5"
                data-testid="contact-text-link"
              >
                <MessageCircle className="h-3.5 w-3.5" /> Text Us
              </a>
            </div>
            <div className="flex items-start gap-3">
              <Clock className="h-5 w-5 text-[color:var(--neon-red)] mt-0.5" />
              <div>
                <div className="font-display uppercase tracking-[0.14em] text-[11px] text-white/55">
                  Hours
                </div>
                <ul className="mt-1 space-y-0.5 text-white text-sm font-mono-ui">
                  {SCHOOL.hours.map((h) => (
                    <li key={h.day}>
                      <span className="text-white/55">{h.day}: </span>
                      {h.hours}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="flex flex-wrap gap-2 pt-2">
              <Button
                onClick={() => openLeadModal('contact-primary')}
                className="w-full sm:w-auto bg-[color:var(--neon-red)] hover:bg-[#ff3a3a] text-white font-display uppercase tracking-[0.14em] rounded-xl px-5 py-5 min-h-[48px] glow-red-sm"
                data-testid="contact-book-trial-button"
              >
                Book Free Trial
              </Button>
              <a
                href={SCHOOL.directionsUrl}
                target="_blank"
                rel="noreferrer"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 font-display uppercase tracking-[0.14em] text-xs text-white border border-white/15 hover:bg-white/5 rounded-xl px-5 py-3 min-h-[48px]"
                data-testid="contact-directions-button"
              >
                <MapPin className="h-4 w-4" /> Get Directions
              </a>
            </div>
          </div>
        </div>

        <div className="lg:col-span-6">
          <div className="relative panel rounded-2xl overflow-hidden h-[280px] sm:h-[420px] lg:h-full min-h-[280px] lg:min-h-[360px]">
            <iframe
              title="Universal Kempo Karate location"
              src="https://www.google.com/maps?q=2380+Montebello+Dr+W+Colorado+Springs+CO+80918&hl=en&output=embed"
              className="absolute inset-0 w-full h-full"
              style={{ filter: 'grayscale(0.6) contrast(1.05) saturate(0.8)', border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              data-testid="contact-map-iframe"
            />
            <div className="pointer-events-none absolute inset-0" style={{ background: 'linear-gradient(to top, rgba(7,8,10,0.5), transparent 30%)' }} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
